import { useEffect, useRef, useState } from 'react'

// True once the element has been a quarter on screen, and stays true, so a
// card's motion plays the first time it scrolls into view and never again.
// Without IntersectionObserver it is true straight away.
export function useInView<T extends Element>(): [React.RefObject<T>, boolean] {
  const ref = useRef<T>(null)
  const [inView, setInView] = useState(typeof IntersectionObserver === 'undefined')

  useEffect(() => {
    const element = ref.current
    if (inView || !element) return undefined

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setInView(true)
          observer.disconnect()
        }
      },
      { threshold: 0.25 }
    )
    observer.observe(element)

    return () => observer.disconnect()
  }, [inView])

  return [ref, inView]
}
